export const STAGE_FOCUSED = 'stage';

export const TIMELINE_FOCUSED = 'timeline';
